<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/authoring_list']" [queryParams]="{tab:tab}"><img
            src="assets/images/admin/backarrow.png" /> Back to Content Authoring</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>

<div class="mt-4 pt-2">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="userDetail">
                    <h2>{{contentDetailsData?.capsule_name}}<small>Created on
                            {{contentDetailsData?.created_dttm}}</small></h2>
                    <ul class="modifyIcons mb-0">
                        <li
                            *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''">
                            <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg"></a>
                        </li>
                        <li
                            *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'1')==true)">
                            <a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a>
                        </li>
                        <li
                            *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'2')==true)">
                            <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a>
                        </li>
                        <li
                            *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'3')==true)">
                            <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-8">
                <ul class="customTab">
                    <!--  [routerLink]="['/authoring_avtivated']" -->
                    <li><a href="javascript:void(0);" [routerLink]="['/authoring-activated-course']"
                            [queryParams]="{id:this.content_capsule_id}">ACTIVE COURSES<br />
                            (ASSIGNED TO)</a> </li>
                    <!--  [routerLink]="['/authoring_deavtivated']" -->
                    <li><a href="javascript:void(0);" [routerLink]="['/authoring-deactivated-course']"
                            [queryParams]="{id:this.content_capsule_id}">DEACTIVATED COURSES<br />
                            (ASSIGNED TO)</a> </li>
                    <!-- [routerLink]="['/user_edit'] [routerLink]="['/user_deactive']" [routerLink]="['/authoring_viewContent']" [queryParams]="{id:contentDetailsData.content_capsule_id}"-->
                    <li><a href="javascript:void(0);" class="active" [routerLink]="['/authoring_viewContent']"
                            [queryParams]="{id:this.content_capsule_id}">VIEW</a> </li>
                    <li><a href="javascript:void(0);" (click)="open(duplicate,this.content_capsule_id)">Duplicate</a>
                    </li>
                    <li class="deactiveTab" *ngIf="contentDetailsData?.is_active == 1"><a href="javascript:void(0);"
                            (click)="open(deactivate,this.content_capsule_id)">DEACTIVATE</a> </li>
                    <li class="deactiveTab" *ngIf="contentDetailsData?.is_active == 0"><a href="javascript:void(0);"
                            (click)="open(activate,this.content_capsule_id)">ACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-6">
            <h2>View Content Capsule</h2>
        </div>
    </div>
</div>
<!-- <div class="sttperWrap pt-1 mb-4">
    <div class="sttperBody sttperContentBody mt-3">
        <div class="row m-0">
        <ul class="modifyIcons">
                <li *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''"><a href="javascript:void(0);"><img src="assets/images/icons/frame.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'1')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'2')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'3')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a></li>
            </ul>
        </div>
        <div *ngIf="(contentDetailsData?.contentCapsuleMedia)">
            <div *ngFor="let media of contentDetailsData.contentCapsuleMedia; let i = index">
                <h4 *ngIf="(media.media_type==2 || media.media_type==3)">{{media.media_title}}</h4>
                <p class="pt-3" *ngIf="(media.media_type==1 || media.media_type==2 || media.media_type==3)" [innerHtml]='media.media_content'></p>
                <div class="videoUrlWrap" *ngIf="(media.media_type==3)">
                    <video controls >
                        <source src="{{media.media_path}}" type="video/mp4">
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
                <div class="videoImgWrap mt-4 mb-4"  *ngIf="(media.media_type==2)">
                    <img src="{{media.media_path}}">
                </div>
                <hr/>
            </div>
        </div> 
    </div>
    <div class="sttperFooter" *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''">
        <div class="row m-0">
            <div class="m-auto">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-1 mr-1" [routerLink]="['/authoring_assessment_view']"
                [queryParams]="{id:contentDetailsData.assessment_id,capsuleId:contentDetailsData.content_capsule_id,capName:contentDetailsData.capsule_name,tab:tab}"><span>View assessment</span></a>
            </div>
        </div>
    </div>
</div> -->
<div class="dynamicBookWrap contentData">
    <div class="dynamicPlugin p-0">
        <mat-horizontal-stepper #stepper [@.disabled]="true" selectedIndex="0">
            <mat-step *ngFor="let subValues of contentDetailsMediaData; let j = index">
                <div class="stepperCenter">
                    <div class="container">
                        <div class="row">
                            <div class="viverContent" *ngIf="subValues.media_type==1">
                                <div class="viverContentList">
                                    <h4 *ngIf="(subValues.media_type==2 || subValues.media_type==3)">
                                        {{subValues.media_title}}</h4>
                                    <p class="pt-3" [innerHtml]='subValues.media_content'></p>
                                </div>
                            </div>
                            <div class="col-lg-12" *ngIf="subValues.media_title !='' && subValues.media_type==2">
                                <h4>{{subValues?.media_title}}</h4>
                            </div>
                            <div class="viverContent" *ngIf="subValues.media_type==2">
                                <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                    <!-- <h4 *ngIf="subValues.media_title !=''">{{subValues?.media_title}}</h4> -->
                                    <p class="pt-3" *ngIf="subValues.media_content !=''"
                                        [innerHtml]='subValues.media_content'></p>
                                </div>
                                <div class="viverContentList" *ngIf="subValues.media_path !=''">
                                    <div class="imageWrap">
                                        <img src={{subValues.media_path}}>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12" *ngIf="subValues.media_title !='' && subValues.media_type==3">
                                <h4>{{subValues?.media_title}}</h4>
                            </div>
                            <div class="viverContent" *ngIf="subValues.media_type==3">
                                <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                    <!-- <h4>{{subValues?.media_title}}</h4> -->
                                    <p class="pt-3" [innerHtml]='subValues.media_content'></p>
                                </div>
                                <div class="viverContentList" *ngIf="subValues.media_path !=''">
                                    <div class="imageWrap">
                                        <!-- <video controls>
                                            <source src={{subValues.media_path}} type="video/mp4">
                                            Sorry, your browser doesn't support embedded videos.
                                        </video> -->
                                        <video fireVideo src={{subValues.media_path}} controls="true" muted width="400" controlsList="nodownload" oncontextmenu="return false;">
                                            Sorry, your browser doesn't support embedded videos.
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <button mat-button matStepperPrevious *ngIf="j !=0"> <img
                                    src="assets/images/icons/preview-arrow.png" /> Previous</button>
                            <button mat-button matStepperNext
                                *ngIf="contentDetailsData.contentCapsuleMedia.length-1 != j">Next<img
                                    src="assets/images/icons/next-arrow.png" /></button>

                            <!-- <button mat-button matStepperNext
                                *ngIf="capsuleData.subModules.media_data.length-1 == j && capsuleData.subModules.assessment_id == null"
                                (click)="finishSubModule(view)">Finish Sub Module</button> -->
                            <!-- <button mat-button matStepperNext
                                *ngIf="view==1 && capsuleData.subModules.media_data.length-1 ==j" (click)="finishSubModule(view)">Finish Sub Module</button> -->
                            <!-- <button class="btn btn-primary takeass"
                                *ngIf="capsuleData.subModules.media_data.length-1 ==j && view !=1 && view !=2  && capsuleData.subModules.assessment_id != null"
                                 (click)="goToAssessment()">Take Assessments</button> -->
                            <!-- <button class="btn btn-primary takeass"
                                 *ngIf="capsuleData.subModules.media_data.length-1 ==j && capsuleData.subModules.assessment_id != null"
                                  (click)="goToAssessment()">Take Assessments</button> -->
                            <div class="pagecountNumber "><b class="">{{j+1}}</b>/<b
                                    class="">{{contentDetailsData.contentCapsuleMedia.length}}</b>
                                <a href="javascript:void(0);"
                                    *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''"
                                    class="btn btn-primary btn-sm ml-1 mr-1"
                                    [routerLink]="['/authoring_assessment_view']"
                                    [queryParams]="{id:contentDetailsData.assessment_id,capsuleId:contentDetailsData.content_capsule_id,capName:contentDetailsData.capsule_name,tab:tab}"><span>View
                                        assessment</span></a>
                            </div>

                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
        <div class="pagiMainWrap">
            <div class="container">
                <div class="row">
                    <div class="pagiWrap">
                        <div class="pagecount "><b class="d-none">1</b><b class="d-none">5</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate content capsule</h6>
                <p class="size18">Are you sure you want to deactivate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(content_capsule_ids,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate content capsule</h6>
                <p class="size18">Are you sure you want to activate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(content_capsule_ids,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate content capsule</h6>
                <p class="size18">Are you sure you want to Duplicate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCapsule(content_capsule_ids)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>